import React, { forwardRef, useImperativeHandle } from 'react'
import { Input, Row, Col, DatePicker, Form } from 'antd'
import dayjs from 'dayjs'
import { formatMessage } from '@/utils/common'
import SelectAll from '@/components/searchbar/SelectAll'
const { TextArea } = Input
const { RangePicker } = DatePicker
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
}
const SearchBar = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      getInfo: () => {
        return initForm.validateFields()
      },
      clearForm: keys => {
        initForm.resetFields(keys)
      },
      getValue: keys => {
        return initForm.getFieldsValue(keys)
      },
      setValue: obj => {
        // const form = initForm.useFormInstance()
        return initForm.setFieldsValue(obj)
      }
    }
  })
  const [initForm] = Form.useForm()
  const checkallChange = (ls, key) => {
    initForm.setFieldValue(key, ls)
  }
  const defaultRangePresets = [
    {
      label: formatMessage('languageObj.commonLocale.last7'),
      value: [dayjs().add(-7, 'd'), dayjs()]
    },
    {
      label: formatMessage('languageObj.commonLocale.last30'),
      value: [dayjs().add(-30, 'd'), dayjs()]
    },
    {
      label: formatMessage('languageObj.commonLocale.last90'),
      value: [dayjs().add(-90, 'd'), dayjs()]
    }
  ]
  const { searchList = [], formLayout = {} } = props
  return (
    <>
      <Form form={initForm} style={{ width: '100%' }} colon={false} {...formItemLayout} {...formLayout}>
        <Row type="flex" gutter={[4, 8]}>
          {searchList.map((item, idx) => {
            let {
              type,
              label,
              key,
              initialValues,
              handleChange,
              selectList,
              spans,
              remove,
              showAll,
              showRangePresets,
              itemCol,
              ...resItem
            } = item
            if (remove) {
              selectList = selectList.filter(filterItem => filterItem.value !== remove)
            }
            let resDom = <span></span>
            switch (type) {
              case 'input':
                resDom = (
                  <Input
                    allowClear
                    placeholder={formatMessage('languageObj.commonLocale.placeholderInput')}
                    onChange={e => handleChange && handleChange(e, idx, item)}
                    disabled={item.disabled}
                    {...resItem}
                  />
                )
                break
              case 'textArea':
                resDom = (
                  <TextArea
                    allowClear
                    placeholder={formatMessage('languageObj.commonLocale.placeholderInput')}
                    onChange={e => handleChange && handleChange(e, idx, item)}
                    disabled={item.disabled}
                    {...resItem}
                  />
                )
                break
              case 'select':
                let allowClearFlag = false
                if (item.mode === 'multiple') {
                  allowClearFlag = true
                }
                resDom = (
                  <SelectAll
                    selectAllBack={e => {
                      checkallChange(e, key)
                      handleChange && handleChange(e, idx, item)
                    }}
                    allowClearFlag={allowClearFlag}
                    showAll={showAll}
                    initialValues={initialValues}
                    selectList={selectList}
                    onChange={item.onChange} // ✅ 关键：把 onChange 显式传给 SelectAll
                    {...resItem}
                  />
                )
                break
              case 'timeRange':
                resDom = (
                  <RangePicker
                    presets={showRangePresets && defaultRangePresets}
                    style={{ width: '100%' }}
                    format={item.format}
                    onChange={e => handleChange && handleChange(e, idx, item)}
                    {...resItem}
                  />
                )
                break
              case 'time':
                resDom = (
                  <DatePicker
                    style={{ width: '100%' }}
                    format={item.format}
                    onChange={e => handleChange && handleChange(e, idx, item)}
                    {...resItem}
                  />
                )
                break
              case 'text':
                resDom = <div className="word_break_all">{initialValues}</div>
                break
              case 'html':
                resDom = item.htmlDom
                break

              default:
                resDom = <span></span>
                break
            }
            return (
              <Col key={idx} xs={24} sm={12} md={12} lg={8} xl={8} xxl={6} {...spans}>
                {label ? (
                  <Row type="flex" justify="space-between" align="middle">
                    <Form.Item
                      label={formatMessage(label) || label}
                      name={key}
                      initialValue={initialValues}
                      style={{ width: '100%', margin: 0 }}
                      className="search_form_label"
                      {...itemCol}
                    >
                      {resDom}
                    </Form.Item>
                  </Row>
                ) : (
                  resDom
                )}
              </Col>
            )
          })}
          {props.children}
        </Row>
      </Form>
    </>
  )
})
export default React.memo(SearchBar)
